import { BFormSpinbutton } from "bootstrap-vue";
import { createEgBootstrapProxy } from "../createEgBootstrapProxy";

export const EgBFormSpinbutton = createEgBootstrapProxy(
  "EgBFormSpinbutton",
  BFormSpinbutton
);
